<template>
  <div
    class="individual_wrap"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div class="rotation">
      <ul class="swiper-no-swiping" id="swiperContent" v-if="isOpen">
        <div class="search_ipt">
          <el-input
            v-model="courseName"
            @keyup.enter.native="getCourseList()"
            @input.native="getCourseList()"
            placeholder="请输入课程名称"
            clearable
          ></el-input>
        </div>
        <transition-group tag="li" class="container" v-if="resourceData.length">
          <li
            :class="{ active: index === $store.state.activeIndex }"
            v-for="(data, index) in resourceData"
            :key="data.id"
            class="swiper_list"
            draggable="true"
          >
            <div class="swiper_items" @click="sendMsg(data, index)">
              <div class="imgBox"></div>
              <span>{{ data.courseName }}</span>
            </div>
          </li>
        </transition-group>
        <div class="noCourse" v-else>
          <img src="../../../../static/images/common/noorder_pic.png" />
          <p>暂无课程</p>
        </div>
      </ul>
      <img
        src="../../../../static/images/course/close.png"
        alt=""
        v-if="isOpen"
        class="switchImg open"
        @click="isOpen = false"
      />
      <img
        src="../../../../static/images/course/open.png"
        alt=""
        v-else
        class="switchImg close"
        @click="isOpen = true"
      />
    </div>
    <div
      class="individual_cont"
      :style="
        resourceData.length > 1
          ? isOpen
            ? 'width: calc(240 - 100%)'
            : 'width: 100%'
          : 'width: 100%'
      "
    >
      <div class="individual_active" v-if="resourceData.length">
        <div
          class="course_cont"
          :class="resourceData.length > 1 ? 'courseNone' : 'courseCout'"
        >
          <div class="course">
            <div class="course_left">
              <img
                :src="
                  courseParam.courseLogo ? courseParam.courseLogo : courseDefPic
                "
              />
            </div>
            <div
              class="course_right"
              :class="productFlag == 3 || 4 ? 'productFlag1' : 'productFlagf'"
            >
              <h3 :title="courseParam.courseName">
                <i v-if="courseParam.status == 0 && productFlag != 4">更新中</i
                >{{ courseParam.courseName }}
              </h3>
              <div class="icons" v-if="productFlag == 3 || productFlag == 4">
                <div class="business icons-item">
                  <img
                    src="../../../../static/images/course/teachClassIcon/task-sm.png"
                  />
                  <span>任务数量：{{ courseParams.taskNum }}</span>
                </div>
              </div>
              <p class="course_context">
                {{
                  "课程简介：" + courseParam.courseContext
                    ? courseParam.courseContext
                    : "无"
                }}
              </p>
              <el-button type="primary" @click="courseAdmin(courseParam)"
                >开课管理</el-button
              >
            </div>
          </div>
        </div>
        <div class="data_num">
          <ul>
            <li>
              <img
                src="../../../../static/images/course/teachClassIcon/kejian2.png"
              />
              <div>
                <h3>
                  {{
                    courseParam.courseHour == null ? 0 : courseParam.courseHour
                  }}
                </h3>
                <span>课时</span>
              </div>
            </li>
            <li v-if="productFlag != 3 && productFlag != 1 && productFlag != 4">
              <img
                src="../../../../static/images/course/teachClassIcon/task2.png"
              />
              <div>
                <h3>{{ courseParams.taskNum }}</h3>
                <span>任务</span>
              </div>
            </li>
            <li v-if="productFlag == 1">
              <img
                src="../../../../static/images/course/teachClassIcon/ziyuan.png"
              />
              <div>
                <h3>{{ courseParams.taskNum }}</h3>
                <span>资源</span>
              </div>
            </li>
            <li>
              <img
                src="../../../../static/images/course/teachClassIcon/class2.png"
              />
              <div>
                <h3>{{ courseParams.classNum }}</h3>
                <span>班级</span>
              </div>
            </li>
            <li v-if="productFlag == 3 || productFlag == 4">
              <img
                src="../../../../static/images/course/teachClassIcon/xiaozu.png"
              />
              <div>
                <h3>{{ courseParams.teamNum }}</h3>
                <span>小组</span>
              </div>
            </li>
            <li>
              <img
                src="../../../../static/images/course/teachClassIcon/student2.png"
              />
              <div>
                <h3>{{ courseParams.studentNum }}</h3>
                <span>学生</span>
              </div>
            </li>
          </ul>
          <ul>
            <div class="line"></div>
            <li>
              <img
                src="../../../../static/images/course/teachClassIcon/day2.png"
              />
              <div>
                <h3>{{ courseParams.todayStudyNum }}</h3>
                <span>学习人数</span>
              </div>
            </li>
            <li>
              <img
                src="../../../../static/images/course/teachClassIcon/7day2.png"
              />
              <div>
                <h3>{{ courseParams.weekStudyNum }}</h3>
                <span>学习人数</span>
              </div>
            </li>
            <li>
              <img
                src="../../../../static/images/course/teachClassIcon/30day2.png"
              />
              <div>
                <h3>{{ courseParams.mounthStudyNum }}</h3>
                <span>学习人数</span>
              </div>
            </li>
          </ul>
        </div>
        <div class="class_cont">
          <div class="head_tite"><span></span>开课班级</div>
          <div class="class_list">
            <ul v-if="classData.length">
              <li v-for="(item, index) in classData" :key="index">
                <div class="triangle">
                  <span></span>
                </div>
                <div class="inside">
                  <h3 :title="item.className">{{ item.className }}</h3>
                  <p class="marginTop">
                    <span>开课时间：</span>
                    <span
                      >{{ item.startDate.substring(0, 10) }} 至
                      {{ item.endDate.substring(0, 10) }}</span
                    >
                  </p>
                  <p>
                    <span>邀请码：</span>
                    <span>{{
                      item.invitCode ? item.invitCode : "暂无邀请码"
                    }}</span>
                  </p>
                  <p>
                    <span>学生：</span>
                    <span>{{ item.studentNum }}人 </span>
                  </p>
                  <div class="bottom">
                    <div class="btn" @click="enterClass(item)">进入课堂</div>
                  </div>
                </div>
              </li>
            </ul>
            <div class="noList" v-else>
              <img src="../../../../static/images/common/noorder_pic.png" />
              <p>暂无开课班级</p>
            </div>
          </div>
        </div>
      </div>
      <div class="noLists" v-else>
        <img src="../../../../static/images/common/noorder_pic.png" />
        <p>暂无教学班</p>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from "../../../api/individualApi";
export default {
  data() {
    return {
      styleHeight: window.innerHeight - 470 + "px",
      resourceData: [],
      page: 1,
      courseDefPic: "/static/images/newCourse/courseCover/cover1.png",
      classData: [],
      courseParams: {},
      courseParam: {},
      productFlag: sessionStorage.getItem("productFlag"),
      prodId: sessionStorage.getItem("prodId"),
      loading: true,
      isOpen: true,
      courseName: "",
      dragging: null,
    };
  },
  created() {
    this.getCourseList();
  },
  methods: {
    // 获取所有课程
    getCourseList() {
      let obj = {
        type: this.productFlag,
        courseType: this.productFlag == 4 ? 4 : 3,
        courseProfessional: sessionStorage.getItem("professional"),
        courseName: this.courseName,
        prodId: this.prodId,
      };
      api.getTeachCourse(obj).then((res) => {
        // console.log(res);
        if (res.code == 0) {
          this.loading = false;
          this.resourceData = res.data;
          if (this.resourceData.length > 0) {
            this.getCourseClass(
              this.resourceData[this.$store.state.activeIndex].id
            );
            this.getCourseMsg(
              this.resourceData[this.$store.state.activeIndex].id
            );
            this.courseParam = this.resourceData[this.$store.state.activeIndex];
          }
        }
      });
    },
    // 单个课程信息
    getCourseMsg(id) {
      api.getCourseMsg(id).then((res) => {
        // console.log(res);
        if (res.code == 0) {
          this.courseParams = res.data;
        }
      });
    },
    // 点击课程
    sendMsg(data, index) {
      this.$store.state.activeIndex = index;
      this.getCourseClass(data.id);
      this.getCourseMsg(data.id);
      this.courseParam = data;
      // console.log(this.courseParam);
    },
    // 获取开课班级
    getCourseClass(id) {
      let param = {
        courseId: id,
        courseProfessional: sessionStorage.getItem("professional"),
        type: this.productFlag,
        courseType: this.productFlag == 4 ? 4 : 3,
        prodId: this.prodId,
      };
      api.getCourseClass(param).then((res) => {
        if (res.code == 0) {
          this.classData = res.data;
          if (this.classData.length) {
            this.styleHeight = window.innerHeight - 380 + "px";
          } else {
            this.styleHeight = window.innerHeight - 470 + "px";
          }
        }
      });
    },
    // 跳转开课管理
    courseAdmin(item) {
      console.log(item);
      if (item.status == 0) {
        this.$messageWarning("课程更新中。。。请稍后重试");
      } else {
        api.courseAuth(item.id).then((res) => {
          if (res.code == 0) {
            this.$router.push({
              path: "/courseAdmin",
              query: {
                courseId: item.id,
                courseName: item.courseName,
                subjectId: item.subjectId,
                activeIndex: this.$store.state.activeIndex,
              },
            });
            this.$store.state.activeName = "first";
            sessionStorage.setItem("courseMsg", JSON.stringify(item));
          } else {
            this.$messageWarning(res.msg);
            return;
          }
        });
      }
    },
    enterClass(item) {
      let userType = sessionStorage.getItem("userType");
      if (userType == 0 || userType == 1) {
        this.enterClassJump(item);
      } else {
        if (this.courseParam.status == 1) {
          if (item.classStatus == 1) {
            this.enterClassJump(item);
          } else if (item.classStatus == 2) {
            this.$messageWarning("课程已结束。。。");
            return;
          } else if (item.classStatus == 0) {
            this.$messageWarning("课程未开始。。。");
            return;
          }
        } else {
          this.$messageWarning("课程更新中，敬请期待...");
        }
      }
    },
    enterClassJump(item) {
      api.courseAuth(item.courseId).then((res) => {
        if (res.code == 0) {
          console.log('--item-', item, res)
          sessionStorage.removeItem("handleTreeNodeClick");
          sessionStorage.setItem("isPreview", false);
          sessionStorage.setItem("courseType", item.type);
          sessionStorage.setItem("subjectId", item.subjectId);
          sessionStorage.setItem("courseId", item.courseId);
          sessionStorage.setItem("classId", item.classId);
          sessionStorage.setItem("className", item.className);
          let path = "",
            query = {
              id: item.courseId,
              classId: item.classId,
              className: item.className,
              classStatus: item.classStatus,
              courseName: item.courseName,
              courseType: item.courseType,
              type: item.type,
              isPay: item.isPay,
              courseModel: item.courseModel,
            };
          if (item.modelType == 1) {
            path = "/learning_module";
            this.$router.push({ path, query });
          } else {
            if (this.productFlag == 4) {
              path = "/switch/studentTask";
            } else {
              path = "/switch/courseware/courseDetail";
            }
            const { href } = this.$router.resolve({ path, query });
            window.open(href, "_blank");
          }
        } else {
          this.$messageWarning(res.msg);
          return;
        }
      });
    },
    handleDragStart(e, item) {
      this.dragging = item;
    },
    handleDragEnd(e, item) {
      this.dragging = null;
    },
    //首先把div变成可以放置的元素，即重写dragenter/dragover
    handleDragOver(e) {
      e.dataTransfer.dropEffect = "move"; // e.dataTransfer.dropEffect="move";//在dragenter中针对放置目标来设置!
    },
    handleDragEnter(e, item) {
      e.dataTransfer.effectAllowed = "move"; //为需要移动的元素设置dragstart事件
      if (item === this.dragging) {
        return;
      }
      const newItems = [...this.resourceData];
      const src = newItems.indexOf(this.dragging);
      const dst = newItems.indexOf(item);
      newItems.splice(dst, 0, ...newItems.splice(src, 1));
      this.resourceData = newItems;
    },
  },
};
</script>

<style lang="scss" scoped>
.individual_wrap {
  display: flex;
  flex-direction: row-reverse;
  height: 100%;
  .individual_cont {
    padding: 16px;
    padding-bottom: 0;
    width: calc(100% - 149px);
    overflow-y: auto;
    .noLists {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        display: inline-block;
        margin-top: 10%;
        width: 250px;
        height: 170px;
      }
    }
  }
  .rotation {
    background: #fff;
    position: relative;
    .switchImg {
      width: 16px;
      position: absolute;
      left: -16px;
      top: 0;
      bottom: 0;
      margin: auto;
      cursor: pointer;
      transform: rotate(180deg);
    }
    .search_ipt {
      position: fixed;
      top: 64px;
      right: 6px;
      width: 234px;
      height: 50px;
      line-height: 50px;
      background-color: #fff;
      text-align: center;
      .el-input {
        width: 220px;
        /deep/ .el-input__inner {
          height: 32px;
          line-height: 32px;
        }
      }
    }
    #swiperContent {
      box-sizing: border-box;
      height: 100%;
      padding: 0 10px;
      width: 240px;
      overflow-y: auto;
      padding-top: 55px;
      .swiper_list {
        width: 210px;
        background: #fff;
        height: 72px;
        margin-bottom: 12px;
        cursor: pointer;
        border-radius: 2px;
        border: 1px solid rgba(235, 235, 235, 1);
        transition: all linear 0.3s;
        .swiper_items {
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-start;
          padding: 0 24px;
          .imgBox {
            width: 24px;
            height: 24px;
            background: url(../../../../static/images/course/icon-4_hv.png);
            background-size: 100% 100%;
            margin-right: 20px;
          }
          span {
            width: 138px;
            color: #0d141e;
            font-size: 14px;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            line-height: 20px;
          }
          &:hover {
            .imgBox {
              width: 24px;
              height: 24px;
              background: url(../../../../static/images/course/icon-4.png);
              background-size: 100% 100%;
            }
            span {
              color: #5397f7;
            }
          }
        }
        &:hover {
          box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
        }
      }
      .swiper_list.active {
        box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.16);
        border: 0;
        .imgBox {
          width: 24px;
          height: 24px;
          background: url(../../../../static/images/course/icon-4.png);
          background-size: 100% 100%;
        }
        span {
          color: #5397f7;
        }
      }
      .noCourse {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        justify-content: center;
        img {
          display: inline-block;
          width: 160px;
          height: 115px;
        }
      }
    }
  }
  .top_title {
    position: relative;
    height: 136px;
    img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 4px;
    }
    .pos {
      position: absolute;
      width: 637px;
      height: 66px;
      top: 35px;
      left: 50%;
      margin-left: -318px;
    }
  }
  .courseCout {
    margin-top: 10px;
  }
  .course_cont {
    display: flex;
    justify-content: space-around;
    height: 187px;
    margin-bottom: 10px;
    .course {
      width: 100%;
      height: 100%;
      background: #fff;
      padding: 0 20px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      .course_left {
        width: 240px;
        height: 136px;
        margin-right: 20px;
        img {
          display: block;
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
      }
      .course_right {
        width: calc(100% - 280px);
        h3 {
          font-size: 16px;
          color: #0d141e;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: calc(100% - 47px);
          font-family: Hiragino Sans GB;
          i {
            display: inline-block;
            width: 44px;
            height: 18px;
            font-size: 12px;
            color: #fff;
            background: #fbaa00;
            border-radius: 2px;
            line-height: 18px;
            text-align: center;
            margin-right: 3px;
          }
        }
        .course_context {
          font-size: 12px;
          color: #5d646e;
          margin: 20px 0;
          height: 43px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 20px;
          word-break: break-all;
          word-wrap: break-word;
          white-space: pre-wrap;
        }
        .el-button {
          padding: 8px 44px;
        }
      }
      .productFlag1 {
        h3 {
          margin-top: -5px;
          margin-bottom: 13px;
        }
        p {
          font-size: 12px;
          color: #5d646e;
          margin: 12px 0;
          height: 43px;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          line-height: 20px;
        }
      }
      .icons {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .icons-item {
          display: flex;
          align-items: center;
          margin-right: 100px;
          width: 150px;
        }
        img {
          display: inline-block;
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }
        span {
          font-size: 14px;
          color: #0d141e;
        }
      }
    }
  }
  .productFlag0 {
    ul {
      li {
        justify-content: flex-start !important;
        width: 134px;
      }
    }
  }
  .data_num,
  .productFlag0 {
    height: 56px;
    padding: 16px 26px;
    background: #fff;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .line {
      width: 0px;
      height: 44px;
      border: 1px solid rgba(221, 224, 226, 1);
      margin-left: 35px;
    }
    ul {
      display: flex;
      justify-content: space-between;
      flex: 1;
      li {
        display: flex;
        justify-content: space-around;
        img {
          display: inline-block;
          width: 44px;
          height: 44px;
        }
        div {
          display: flex;
          flex-flow: column;
          justify-content: space-around;
          margin-left: 8px;
          h3 {
            font-size: 20px;
            color: #5397f7;
          }
          span {
            font-size: 12px;
            color: #858c96;
          }
        }
      }
      &:last-child {
        margin-right: 0;
      }
    }
  }
  .class_cont {
    background: #fff;
    .head_tite {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 42px;
      border-bottom: 2px solid #dde0e2;
      span {
        display: inline-block;
        width: 6px;
        height: 16px;
        background: rgba(83, 151, 247, 1);
        font-size: 16px;
        color: #0d141e;
        margin-left: 32px;
        margin-right: 4px;
      }
    }
    .class_list {
      padding: 30px 24px;
      min-height: 200px;
      padding-bottom: 0;
      ul {
        display: flex;
        flex-wrap: wrap;
        li {
          position: relative;
          width: 280px;
          height: 200px;
          background: rgba(213, 218, 237, 1);
          border: 6px solid rgba(213, 218, 237, 1);
          border-radius: 8px;
          margin: 32px 8px 30px 0;
          display: flex;
          align-items: center;
          justify-content: space-around;
          .inside {
            width: 229px;
            height: 157px;
            background: #fff;
            padding: 12px 16px;
            h3 {
              color: #0d141e;
              font-size: 16px;
              text-align: center;
              border-bottom: 1px solid #d5daed;
              padding-bottom: 15px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            p {
              display: flex;
              justify-content: space-between;
              line-height: 26px;
              span {
                color: #b4bbcd;
                font-size: 12px;
              }
            }
            .marginTop {
              margin-top: 10px;
            }
            .bottom {
              display: flex;
              justify-content: center;
            }
            .btn {
              width: 90px;
              height: 30px;
              background: rgba(83, 151, 247, 1);
              border-radius: 4px;
              color: #fff;
              line-height: 30px;
              text-align: center;
              font-size: 14px;
              cursor: pointer;
            }
          }
          .triangle {
            position: absolute;
            width: 0;
            height: 0;
            border-top: 46px solid transparent;
            border-right: 46px solid transparent;
            border-bottom: 46px solid #b4bbcd;
            border-left: 46px solid transparent;
            border-radius: 2px;
            top: -98px;
            span {
              position: absolute;
              width: 0;
              height: 0;
              border-top: 40px solid transparent;
              border-right: 40px solid transparent;
              border-bottom: 40px solid #fff;
              border-left: 40px solid transparent;
              top: -34px;
              left: -40px;
            }
          }
        }
      }
      .noList {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          display: inline-block;
          width: 250px;
          height: 160px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/TeachClass/index.vue